 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0010bc76":"3f420c25","chunk-1de0c504":"e68b0b78","chunk-255f64e3":"8385e764","chunk-2651852d":"e613aa94","chunk-26859e1c":"9e76c1db","chunk-2d22d3f4":"ab9e231a","chunk-907ebc00":"19131645","chunk-33d46f00":"edcb68d8","chunk-a49e28aa":"8440c337","chunk-3804297c":"f6968170","chunk-50fd203d":"0a14b11c","chunk-588a8186":"2ed8ad9f","chunk-5e550473":"5f523d80","chunk-6161b3c2":"bd8373b4","chunk-656c0c48":"4e53a74f","chunk-895e17c2":"01670c5c","chunk-106ffed5":"3d970ef7","chunk-8f8222b8":"6e69acd9","chunk-34f4301d":"c155af5b","chunk-43197b96":"bf56e842","chunk-ab1e02b2":"ca293528","chunk-880a0a46":"6afbaf0d","chunk-da2509c2":"4e98b9fe","chunk-5e835c93":"0637e2a5","chunk-b6625c2c":"d9c41809","chunk-b7824540":"5ae2c45d","chunk-bd08044c":"32e060b2","chunk-c1213a52":"9902d0ac","chunk-1c51b0c3":"c033fb3f","chunk-0027e536":"214b6b26","chunk-12abccfa":"7946be59","chunk-4fba8514":"3b208205","chunk-5f16e7ae":"31b55776","chunk-e32d3554":"e7c635f8","chunk-608c194e":"4b209798","chunk-21c783b8":"6eb6188f","chunk-e4fe65dc":"69746a12","chunk-edd189b8":"cd8b71f4","chunk-fdda97ae":"9591e841","chunk-743c2ddb":"a76340f5","chunk-7457c560":"de003d3e","chunk-745a3122":"a496ad2d","chunk-7467d5b8":"81acc37a","chunk-7482e5bc":"a45e4312","chunk-74af77ea":"72d835d8","chunk-74b7681c":"af3b4519","chunk-74bb0962":"1d1c34d4","chunk-76f042f8":"cf4c94f3","chunk-774c8cf7":"d2e748d9","chunk-8e746eec":"6cdd1f07","chunk-11f3b708":"f9bede90","chunk-11ff409a":"c8b3ad16","chunk-1bacba11":"0d07e1d3","chunk-1d3845ba":"1e9b37b8","chunk-2ad945e0":"9416520c","chunk-2d2223ef":"63841fb3","chunk-3eb4076b":"a40f032e","chunk-520ab7e2":"b229257b","chunk-77755481":"727f09ae","chunk-a4a5f68c":"5cb9f423","chunk-c165a772":"25789ead","chunk-26a93a8e":"442c158f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0010bc76":1,"chunk-1de0c504":1,"chunk-255f64e3":1,"chunk-2651852d":1,"chunk-26859e1c":1,"chunk-907ebc00":1,"chunk-a49e28aa":1,"chunk-3804297c":1,"chunk-50fd203d":1,"chunk-588a8186":1,"chunk-5e550473":1,"chunk-6161b3c2":1,"chunk-656c0c48":1,"chunk-106ffed5":1,"chunk-8f8222b8":1,"chunk-34f4301d":1,"chunk-43197b96":1,"chunk-ab1e02b2":1,"chunk-880a0a46":1,"chunk-da2509c2":1,"chunk-5e835c93":1,"chunk-b6625c2c":1,"chunk-b7824540":1,"chunk-bd08044c":1,"chunk-c1213a52":1,"chunk-1c51b0c3":1,"chunk-0027e536":1,"chunk-12abccfa":1,"chunk-4fba8514":1,"chunk-e32d3554":1,"chunk-608c194e":1,"chunk-21c783b8":1,"chunk-e4fe65dc":1,"chunk-edd189b8":1,"chunk-fdda97ae":1,"chunk-743c2ddb":1,"chunk-7457c560":1,"chunk-745a3122":1,"chunk-7467d5b8":1,"chunk-7482e5bc":1,"chunk-74af77ea":1,"chunk-74b7681c":1,"chunk-74bb0962":1,"chunk-76f042f8":1,"chunk-774c8cf7":1,"chunk-8e746eec":1,"chunk-11f3b708":1,"chunk-11ff409a":1,"chunk-1bacba11":1,"chunk-1d3845ba":1,"chunk-2ad945e0":1,"chunk-3eb4076b":1,"chunk-520ab7e2":1,"chunk-77755481":1,"chunk-a4a5f68c":1,"chunk-c165a772":1,"chunk-26a93a8e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0010bc76":"9296cf4a","chunk-1de0c504":"3a4a1d1f","chunk-255f64e3":"1854eb81","chunk-2651852d":"5a17e23d","chunk-26859e1c":"88b910f9","chunk-2d22d3f4":"31d6cfe0","chunk-907ebc00":"25237b9b","chunk-33d46f00":"31d6cfe0","chunk-a49e28aa":"a8a75326","chunk-3804297c":"9f69edb5","chunk-50fd203d":"e71fcd5e","chunk-588a8186":"c3ad9921","chunk-5e550473":"c3ad9921","chunk-6161b3c2":"39b456c1","chunk-656c0c48":"705b1b3c","chunk-895e17c2":"31d6cfe0","chunk-106ffed5":"57cfd08b","chunk-8f8222b8":"0441cf18","chunk-34f4301d":"5e9635bb","chunk-43197b96":"18d91ad1","chunk-ab1e02b2":"6708f651","chunk-880a0a46":"020add63","chunk-da2509c2":"5bbf567b","chunk-5e835c93":"bcdad9a8","chunk-b6625c2c":"da245d50","chunk-b7824540":"cf5ce7ea","chunk-bd08044c":"ef0da253","chunk-c1213a52":"9ab79886","chunk-1c51b0c3":"f12bbdd2","chunk-0027e536":"cd1ed8c1","chunk-12abccfa":"3c2dcc28","chunk-4fba8514":"a0db8056","chunk-5f16e7ae":"31d6cfe0","chunk-e32d3554":"4da37146","chunk-608c194e":"1cc11e3b","chunk-21c783b8":"8ea97ceb","chunk-e4fe65dc":"e71fcd5e","chunk-edd189b8":"3def792d","chunk-fdda97ae":"55ec8d40","chunk-743c2ddb":"0dd2478f","chunk-7457c560":"d4ad834b","chunk-745a3122":"d7dc1639","chunk-7467d5b8":"97906909","chunk-7482e5bc":"3fc962f4","chunk-74af77ea":"23b17eb2","chunk-74b7681c":"6ff76692","chunk-74bb0962":"06c127ee","chunk-76f042f8":"a3d504dc","chunk-774c8cf7":"93e9293c","chunk-8e746eec":"d5fe83ac","chunk-11f3b708":"a6a6a033","chunk-11ff409a":"9c9dce81","chunk-1bacba11":"3d644a50","chunk-1d3845ba":"5642d03a","chunk-2ad945e0":"64023625","chunk-2d2223ef":"31d6cfe0","chunk-3eb4076b":"10420059","chunk-520ab7e2":"fc1e098b","chunk-77755481":"ba85b2e9","chunk-a4a5f68c":"417c6c07","chunk-c165a772":"574d4e55","chunk-26a93a8e":"dab78955"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://presenter.ahaslides.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
